import { CounterProps } from './types';

import * as S from './styles';

const Counter: React.FC<CounterProps> = ({ number, ...props }) => {
  return (
    <S.Counter data-testid="counter" {...props}>
      <S.CounterNumber>{number || '!'}</S.CounterNumber>
    </S.Counter>
  );
};

export default Counter;
